var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('source-count-table',{attrs:{"title":"Insufficient data to generate the requested estimate","note":"The following are counts where both variables are not null.","columnHeadings":_vm.columnHeadings,"rows":_vm.rows,"rowAndColumnsTheSame":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }